// extracted by mini-css-extract-plugin
export var center = "modal-module--center--6d45a";
export var closeButton = "modal-module--closeButton--f9f8f";
export var genericContainer = "modal-module--genericContainer--f6dcb";
export var left = "modal-module--left--605e8";
export var modal = "modal-module--modal--0889a";
export var overlay = "modal-module--overlay--9e9db";
export var right = "modal-module--right--edd88";